'use client';

import Link from 'next/link';
import { title } from 'process';

const EventsSection = () => {
  const pastEvents = [
    {
      id: 1,
      image: '/images/vc-vault-abu-dhabi.webp',
      title: 'vc-vault-abu-dhabi',
      link: 'https://luma.com/VCVaultabudhabi',
    },
     {
      id: 2,
      image: '/images/events/vc-volt-singapore-luma-event.webp',
      title: 'vc-volt-singapore-luma-event',
      link: 'https://luma.com/p9905tv6',
    },
    {
      id: 3,
      title: 'startup-pitch-teardown-event',
      image: '/images/events/startup-pitch-teardown-event.webp',
      link: 'https://luma.com/Startuppitchteardown'
    },
    {
      id: 4,
      title: 'Blockchain All Stars - An Official Global Blockchain Show + Dubai Tech Tuesdays Collaboration',
      image: '/images/events/blockchain-all-stars-dubai.webp',
      link: 'https://luma.com/BlockchainAllStars'
    },
    
    
  ];

  return (
   
    <section data-component-id="src/app/EventsSection.tsx:38:4" data-component-path="src/app/EventsSection.tsx" data-component-line="38" data-component-file="EventsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22w-full%20bg-secondary-light%20pt-%5B30px%5D%20pb-%5B60px%5D%20%22%7D" id='events' className="w-full bg-secondary-light pt-[30px] pb-[60px] ">
      <div data-component-id="src/app/EventsSection.tsx:39:6" data-component-path="src/app/EventsSection.tsx" data-component-line="39" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1340px%5D%20mx-auto%20px-2%20sm%3Apx-6%20lg%3Apx-%5B56px%5D%22%7D" className="w-full max-w-[1340px] mx-auto px-2 sm:px-6 lg:px-[56px]">
        <div data-component-id="src/app/EventsSection.tsx:40:8" data-component-path="src/app/EventsSection.tsx" data-component-line="40" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B24px%5D%20sm%3Agap-%5B28px%5D%20lg%3Agap-%5B34px%5D%20items-center%20w-full%22%7D" className="flex flex-col gap-[24px] sm:gap-[28px] lg:gap-[34px] items-center w-full">
          {/* Section Header */}
          <div data-component-id="src/app/EventsSection.tsx:42:10" data-component-path="src/app/EventsSection.tsx" data-component-line="42" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B6px%5D%20items-center%20w-full%22%7D" className="flex flex-col gap-[6px] items-center w-full">
            <h2 data-component-id="src/app/EventsSection.tsx:43:12" data-component-path="src/app/EventsSection.tsx" data-component-line="43" data-component-file="EventsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B24px%5D%20lg%3Atext-3xl%20font-semibold%20leading-%5B28px%5D%20sm%3Aleading-%5B32px%5D%20lg%3Aleading-%5B40px%5D%20text-center%20text-text-accent%20font-poppins%22%2C%22textContent%22%3A%22Events%20%26%20Initiatives%22%7D" className="text-[20px] sm:text-[24px] lg:text-3xl font-semibold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-center text-text-accent font-poppins">
              Events & Initiatives
            </h2>
            <p data-component-id="src/app/EventsSection.tsx:46:12" data-component-path="src/app/EventsSection.tsx" data-component-line="46" data-component-file="EventsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B20px%5D%20lg%3Atext-2xl%20font-semibold%20leading-%5B24px%5D%20sm%3Aleading-%5B28px%5D%20lg%3Aleading-%5B36px%5D%20text-center%20text-text-secondary%20font-poppins%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-[18px] sm:text-[20px] lg:text-2xl font-semibold leading-[24px] sm:leading-[28px] lg:leading-[36px] text-center text-text-secondary font-poppins">
              Past Events
            </p>
          </div>

          {/* Event Logos Grid */}
          <div data-component-id="src/app/EventsSection.tsx:52:10" data-component-path="src/app/EventsSection.tsx" data-component-line="52" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%20w-full%22%7D" className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
            {pastEvents.map((logo) => (
              <Link data-component-id="src/app/EventsSection.tsx:54:14" data-component-path="src/app/EventsSection.tsx" data-component-line="54" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20bg-secondary-background%20rounded-md%20p-4%20sm%3Ap-5%20lg%3Ap-6%20shadow-sm%20hover%3Ashadow-md%20transition-shadow%20duration-200%20w-full%20h-%5B160px%5D%20sm%3Ah-%5B200px%5D%20lg%3Ah-%5B240px%5D%22%7D"
                key={logo.id}
                href={logo.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex justify-center items-center bg-secondary-background rounded-md p-4 sm:p-5 lg:p-6 shadow-sm hover:shadow-md transition-shadow duration-200 w-full h-[160px] sm:h-[200px] lg:h-[240px]"
              >
                <img data-component-id="src/app/EventsSection.tsx:61:16" data-component-path="src/app/EventsSection.tsx" data-component-line="61" data-component-file="EventsSection.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-full%20h-%5B120px%5D%20sm%3Ah-%5B180px%5D%20lg%3Ah-%5B220px%5D%20%22%7D"
                  src={logo.image}
                  alt={logo.title}
                  width={180}
                height={80}
                  className="w-full h-[120px] sm:h-[180px] lg:h-[220px] "
                />
              </Link>
            ))}
          </div>

          
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
